export {default} from "./ExtractReportsTemplate"